import React, { useEffect ,useState} from 'react'
import Contactarea from '../Contactarea'
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';
function GetinTouch() {
    const [bannerData , setBannerImage] = useState([]);
  const [bannerLoading , setBannerLoading] = useState(true);
  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        const response = await fetch(`${BASE_URL}/banner/?page=contact`);
        const result = await response.json();
        setBannerImage(result.data[0]);
       
            } catch (error) {
              console.error('Error fetching banner:', error);
            } finally {
              setBannerLoading(false);
            }
          };
          
          fetchBannerImage();
        }, []);
        
       


  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  }, []); 

  
  return (
    <>
     {!bannerLoading && bannerData && bannerData.image ? (
     <div className="breadcumb-wrapper" 
   style={{
    backgroundImage: `url(${BASE_URL}${bannerData.image})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  }}
      data-overlay="title"  
      data-opacity={8}>
        
  <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png"></div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Contact Us</h1>
      <ul className="breadcumb-menu">
        <li><a href="/">Home</a></li>
        <li>Contact Us</li>
      </ul>
    </div>
  </div>
       </div>
     
     ):(<SubLoading/>)}

     <Contactarea/>

    </>
  )
}

export default GetinTouch